import * as angular from 'angular';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { first } from 'rxjs/operators';

export interface SsoOption {
  name: string;
  default: boolean;
  saml: boolean;
  url: string;
}

export const SignInComponent: angular.IComponentOptions = {
  controller: class {
    private $resolve: any;
    public authEmailOrUserParam: string;
    public staticOptions: SsoOption[];
    private aadScimEnabled: boolean;

    static $inject = ['SignInService', '$state', 'FeatureFlagsFacade'];

    constructor(
      private SignInService,
      private $state,
      private featureFlagsFacade: FeatureFlagsFacade
    ) {
      this.featureFlagsFacade
        .asObservable(FeatureFlag.AzureActiveDirectoryScim)
        .pipe(first())
        .subscribe((enabled) => {
          this.aadScimEnabled = enabled;
        });
    }

    $onInit() {
      this.authEmailOrUserParam = this.$resolve.authEmailOrUserParam;
      this.staticOptions = this.staticSsoOptions();
    }

    onEmailSubmit(email: string) {
      this.$state.go('sign-in-options', { auth_email: email });
    }

    public staticSsoOptions(): SsoOption[] {
      const google = { name: 'Google', default: false, saml: false, url: '/auth/google_oauth2' };
      const o365 = { name: 'O365', default: false, saml: false, url: '/auth/azure_oauth2' };

      let result: SsoOption[];

      result = [google, o365];

      return result;
    }
  },
  controllerAs: 'ctrl',
  bindings: {},
  template: `
  <div class="sign-in-container">
    <sign-in-title/>

    <sign-in-input
      auth-email-param="ctrl.authEmailOrUserParam"
      on-email-submit="ctrl.onEmailSubmit($email)"
    />

    <sign-in-toggle-options>
      <span ng-repeat="option in ctrl.staticOptions">
        <sign-in-sso-button option="option">
      </span>
    </sign-in-toggle-options>
  </div>
  `,
};
